import http from "./http"
/*Vue mixins*/
/*
* 视频判断
* 选择诚云还是互视
* */
export const selectVideoChannelMixin = {
    methods:{
        __selectVideoChannel(){
           return http("nethos.system.param.string",{
                key:"CONSULT_GROUP_VIDEO_SP_NAME",
                defaultString:"cci",
            })
        }
    }
}